import { PopupMenuList } from 'shared/components/ui/popup-menu';
import styled from 'styled-components';

export const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const ChildrenContainer = styled(PopupMenuList)`
  padding: 0;
`;
